import * as React from 'react';
import _ from 'lodash';
import { IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const PageNumberSelector = ({ currentPage, setPage, continuationToken}) => {
  return (
    <>
      <IconButton disabled={currentPage == 0} onClick={(event, value) => setPage(currentPage - 1)}>
        <ArrowBackIosIcon />
      </IconButton>
      <IconButton disabled={!continuationToken} onClick={(event, value) => setPage(currentPage + 1)}>
        <ArrowForwardIosIcon />
      </IconButton>
    </>
  );
}
